export default __webpack_public_path__ + "static/media/bz.0bd5780a.svg";